import React, { useState, useRef, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { downloadAPK } from "../../Helpers/DownloadAPK";
// import headerLog from "../../../RichImages/Rich143 logo.svg";
// import download_btn from "../../../RichImages/download_btn.png";
import downloadbutton from "../../../RichImages/downloadbutton.svg";
// import headerLog from "../../../RichImages/Websitelogo12.png";
import headerLog from "../../../RichImages/updatedlogo.svg";

const Navbar = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const collapseRef = useRef(null);

  const handleClickOutside = (event) => {
    if (collapseRef.current && !collapseRef.current.contains(event.target)) {
      setIsCollapsed(true);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="app-container">
        <div className="banner-section">
          <div className="header-container">
            <nav className="navbar navbar-expand-lg">
              <div className="container-fluid header-content-main">
                <div style={{ marginTop: "10px" }}>
                  <Logo />
                </div>
                {/* <button
                  class="navbar-toggler navbar-toggler-btn custom-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span class="navbar-toggler-icon"></span>
                </button> */}
                <div
                  className={`collapse navbar-collapse custome-nav  ${
                    isCollapsed ? "" : "show"
                  }`}
                  id="navbarSupportedContent"
                  ref={collapseRef}
                >
                  <div className="navigation-links"></div>

                  <div className="navigation-links">
                    <NavigationLinks />
                  </div>

                  <div className="download-btn-main-12">
                    <DownloadButton />
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

const Logo = () => {
  return (
    <>
      <Link className="nav-link  active" aria-current="page" to="/">
        <img
          className="logo_navbar"
          src={headerLog}
          alt="https://rich143.com/"
        />
      </Link>
    </>
  );
};

const NavigationLinks = () => {
  return (
    <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
      {/* <li className="nav-item">
        <NavLink
          className="nav-link link-hover-effect"
          // className="nav-link "
          style={{ color: "#075358" }}
          // className={({ isActive }) => (isActive ? "nav-link " : "nav-link ")}
          to="/"
        >
          Home
        </NavLink>
      </li> */}
      {/* <li className="nav-item">
        <NavLink
          style={{ color: "#075358" }}
          // className={({ isActive }) => (isActive ? "nav-link " : "nav-link ")}
          className="nav-link link-hover-effect"
          to="/charts"
        >
          Charts
        </NavLink>
      </li> */}
    </ul>
  );
};

const download = async (e) => {
  e.preventDefault();

  const newTab = window.open("about:blank", "_blank");

  if (!newTab) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  // Only favicon loader (tab ke upar spinner)
  const loaderIcon =
    "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='40' stroke='%23999' stroke-width='8' fill='none' stroke-dasharray='180'><animateTransform attributeName='transform' type='rotate' from='0 50 50' to='360 50 50' dur='1s' repeatCount='indefinite'/></circle></svg>";

  try {
    // Empty page
    newTab.document.open();
    newTab.document.write("<html><head></head><body></body></html>");
    newTab.document.close();

    // Set favicon (THIS IS YOUR “EARTH ICON LOADER”)
    const link = newTab.document.createElement("link");
    link.rel = "icon";
    link.href = loaderIcon;
    newTab.document.head.appendChild(link);

    newTab.document.title = "Loading...";

    const url = await downloadAPK();

    if (!url) {
      newTab.close();
      return;
    }

    // start download (no redirect flicker)
    const a = document.createElement("a");
    a.href = url;
    a.download = "boss555.apk";
    document.body.appendChild(a);
    a.click();
    a.remove();

    setTimeout(() => {
      newTab.close();
    }, 1500);
  } catch (err) {
    newTab.close();
    console.error(err);
  }
};

const DownloadButton = () => {
  return (
    // <a href="#" id="BTTTTT" class="btn1">Download Now</a>
    <>
      {/* <button className="downloadBtn" onClick={download}>
        Download Now
      </button> */}

      <div class="button-container_3">
        <div class="button-container_2">
          <div class="button-container">
            <button class="download-button test" onClick={download}>
              <span>Download App</span>
              &nbsp;
              <img
                className="test_image"
                src={downloadbutton}
                alt="https://rich143.com/"
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
